import { useLightMode } from '@/hooks/useLightMode'

import { Box } from '@hivewatch/dark'

import { getNotificationToastTokens } from '../styles/tokens'

export const NotificationTitle = ({
  title,
  subTitle,
}: {
  title: string
  subTitle: string
}) => {
  const tokens = getNotificationToastTokens(useLightMode())
  return (
    <Box color={tokens.textPrimary} lineClamp={1} textStyle='body-bold'>
      <Box as='span' data-testid='NotificationTitle:title'>
        {title}
      </Box>{' '}
      -{' '}
      <Box as='span' data-testid='NotificationTitle:details'>
        {subTitle}
      </Box>
    </Box>
  )
}
